var _defs, _polygon, _polygon2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelingBuildingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingBuilding_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.31 16.93 19.86 6.9 26.03 7.95 18.66 3.67 10.45 2.27 3.48 11.54 11.53 17.96 12.31 16.93"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.02 22.12 26.99 11.46 20.73 10.4 13.43 20.08 10.44 19.57 3.98 14.5 4.01 24.01 13.85 29.73 19 26.75 19 20.66 22.81 18.46 22.81 18.46 22.81 24.55 27.02 22.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingBuildingSvg);
export default __webpack_public_path__ + "static/media/ModelingBuilding_svg.f13838b46080683af9bd9603d092bcee.svg";
export { ForwardRef as ReactComponent };